<template>
  <section class="hero-section">
    <!-- Fondo animado -->
    <img
      :src="heroBg"
      alt=""
      class="hero-background"
      aria-hidden="true"
      decoding="async"
      fetchpriority="high"
    />

    <!-- Capa para integrar mejor el fondo -->
    <div class="hero-background-overlay" aria-hidden="true"></div>

    <!-- Contenido -->
    <div class="hero-content">
      <img
        :src="logoImg"
        alt="Heaven's Fruit"
        class="hero-logo"
        width="694"
        height="694"
        decoding="async"
        fetchpriority="high"
      />
    </div>
  </section>
</template>

<script>
import logoImg from '@/assets/images/logo.png';
import heroBg from '@/assets/images/hero-bg.png';

export default {
  name: 'HeroComponent',

  data() {
    return {
      logoImg,
      heroBg,
    };
  },
};
</script>

<style scoped>
.hero-section {
  position: relative;

  width: 100%;
  height: 100vh;
  height: 100svh;

  display: flex;
  align-items: center;
  justify-content: center;

  overflow: hidden;
  isolation: isolate;

  background: #000;
}


/* =========================================================
   FADE INFERIOR
   ========================================================= */

.hero-section::after {
  content: '';

  position: absolute;

  z-index: 3;

  left: 0;
  right: 0;
  bottom: 0;

  height: 160px;

  pointer-events: none;

  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, .90) 95%,
    rgba(0, 0, 0, 1) 100%
  );
}


/* =========================================================
   FONDO
   ========================================================= */

.hero-background {
  position: absolute;

  /*
   * Lo hacemos ligeramente más grande que el hero
   * para que al moverse nunca aparezcan bordes negros.
   */
  width: 104%;
  height: 104%;

  left: -2%;
  top: -2%;

  object-fit: cover;
  object-position: center bottom;

  z-index: 0;

  pointer-events: none;
  user-select: none;

  /*
   * Optimización para que la animación quede
   * principalmente en GPU.
   */
  will-change: transform;
  backface-visibility: hidden;

  /*
   * Movimiento lento de las nubes.
   */
  animation: heroBgDrift 16s ease-in-out infinite alternate;
}


/* =========================================================
   ANIMACIÓN DEL FONDO
   ========================================================= */

@keyframes heroBgDrift {
  0% {
    transform:
      translate3d(-1.5%, 0, 0)
      scale(1.02);
  }

  50% {
    transform:
      translate3d(1%, -1%, 0)
      scale(1.045);
  }

  100% {
    transform:
      translate3d(2%, -2%, 0)
      scale(1.06);
  }
}


/* =========================================================
   OVERLAY
   ========================================================= */

.hero-background-overlay {
  position: absolute;

  inset: 0;

  z-index: 1;

  pointer-events: none;

  background:
    linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0.22) 0%,
      rgba(0, 0, 0, 0.08) 35%,
      rgba(0, 0, 0, 0) 65%
    );
}


/* =========================================================
   CONTENIDO
   ========================================================= */

.hero-content {
  position: relative;

  z-index: 2;

  width: 100%;
  height: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
}


/* =========================================================
   LOGO
   ========================================================= */

.hero-logo {
  display: block;

  width: auto;
  height: auto;

  max-width: min(88vw, 684px);
  max-height: min(82vh, 684px);

  transform: translateY(-5vh);

  pointer-events: none;
  user-select: none;

  filter:
    drop-shadow(
      0 12px 40px rgba(255, 255, 255, 0.06)
    );
}


/* =========================================================
   MOBILE
   ========================================================= */

@media (max-width: 768px) {
  .hero-background {
    width: 116%;
    height: 116%;

    left: -8%;
    top: -8%;

    object-position: center bottom;

    animation: heroBgDriftMobile 14s ease-in-out infinite alternate;
  }

  .hero-logo {
    max-width: 92vw;
    max-height: 72vh;

    transform: translateY(-6vh);
  }
}

@keyframes heroBgDriftMobile {
  from { transform: translate3d(-3%, 1%, 0) scale(1.02); }
  to { transform: translate3d(3%, -1%, 0) scale(1.06); }
}


/* =========================================================
   REDUCED MOTION
   ========================================================= */

@media (prefers-reduced-motion: reduce) {
  .hero-background {
    animation: none;

    transform: scale(1.03);
  }
}
</style>
